import React from "react";
import EnquiryForm from "@/components/EnquiryForm";
import { COMPANY } from "@/lib/api";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";

export default function Contact() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="contact-page">
      <div className="max-w-3xl">
        <div className="eyebrow">Contact us</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0A192F] mt-3">Talk to a GPS specialist</h1>
        <p className="mt-4 text-slate-600">We usually respond within a few hours on business days. For urgent queries, WhatsApp is fastest.</p>
      </div>

      <div className="mt-10 grid lg:grid-cols-3 gap-6">
        <a href={`tel:${COMPANY.phone}`} className="p-6 rounded-2xl border border-slate-200 bg-white tile-hover" data-testid="contact-call">
          <Phone className="w-5 h-5 text-[#FF6D00]" />
          <div className="mt-3 text-xs uppercase tracking-widest text-slate-500">Call us</div>
          <div className="font-heading text-lg font-bold text-[#0A192F]">{COMPANY.phoneDisplay}</div>
        </a>
        <a href={`mailto:${COMPANY.email}`} className="p-6 rounded-2xl border border-slate-200 bg-white tile-hover" data-testid="contact-email">
          <Mail className="w-5 h-5 text-[#FF6D00]" />
          <div className="mt-3 text-xs uppercase tracking-widest text-slate-500">Email</div>
          <div className="font-heading text-base font-bold text-[#0A192F] break-all">{COMPANY.email}</div>
        </a>
        <a href={`https://wa.me/${COMPANY.whatsapp}`} target="_blank" rel="noopener noreferrer" className="p-6 rounded-2xl border border-slate-200 bg-white tile-hover" data-testid="contact-whatsapp">
          <MessageCircle className="w-5 h-5 text-[#25D366]" />
          <div className="mt-3 text-xs uppercase tracking-widest text-slate-500">WhatsApp</div>
          <div className="font-heading text-lg font-bold text-[#0A192F]">Chat with us</div>
        </a>
      </div>

      <div className="mt-10 grid lg:grid-cols-2 gap-8">
        <div className="rounded-2xl overflow-hidden border border-slate-200 bg-white">
          <iframe
            title="KSPB Location"
            src="https://www.google.com/maps?q=Jaipur,Rajasthan,India&output=embed"
            className="w-full h-[420px] border-0"
            loading="lazy"
          />
          <div className="p-5 border-t border-slate-100 flex items-start gap-3">
            <MapPin className="w-5 h-5 text-[#FF6D00] mt-0.5" />
            <div>
              <div className="font-semibold text-[#0A192F]">{COMPANY.name}</div>
              <div className="text-sm text-slate-600">{COMPANY.location}</div>
            </div>
          </div>
        </div>

        <EnquiryForm title="Send us a message" subtitle="Fill out the form and our team will reach out shortly." testIdPrefix="contact-form" />
      </div>
    </div>
  );
}
